export default __webpack_public_path__ + "static/media/Vanir Square Shield.94b28737.jpg";